import React, { ReactNode } from 'react';
import Link from '../../paymentJourneyRedesign/shared/library/Link';

const TERMS_PLACEHOLDER = '{{termsAndConditions}}';
const PRIVACY_PLACEHOLDER = '{{privacyNotice}}';
const PRIVACY_POLICY_URL = 'https://www.informa.com/privacy-policy/';
const TERMS_LINK_TEXT = 'Terms and Conditions';
const PRIVACY_LINK_TEXT = 'Privacy Notice';

function renderLinkForPlaceholder(
  placeholder: string,
  termsAndConditionsUrl: string,
): ReactNode {
  if (placeholder === TERMS_PLACEHOLDER) {
    return (
      <Link href={termsAndConditionsUrl} target="_blank">
        {TERMS_LINK_TEXT}
      </Link>
    );
  }

  if (placeholder === PRIVACY_PLACEHOLDER) {
    return (
      <Link href={PRIVACY_POLICY_URL} target="_blank">
        {PRIVACY_LINK_TEXT}
      </Link>
    );
  }

  return placeholder;
}

export function renderAgreementMessage(
  html: string,
  termsAndConditionsUrl: string,
) {
  const parts = html.split(
    /(\{\{termsAndConditions\}\}|\{\{privacyNotice\}\})/g,
  );
  let cursor = 0;

  return parts.map((part) => {
    const key = `agreement-message-part-${cursor}`;
    cursor += part.length;

    return (
      <React.Fragment key={key}>
        {renderLinkForPlaceholder(part, termsAndConditionsUrl)}
      </React.Fragment>
    );
  });
}
